import { X } from "lucide-react";
import { useEffect } from "react";

export default function Drawer({ open, onClose, title, children, footer, wide, testid }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50" data-testid={testid || "drawer"}>
      <div
        className="absolute inset-0 bg-slate-900/40 backdrop-blur-[2px]"
        onClick={onClose}
      />
      <aside
        className={`absolute right-0 top-0 h-full bg-white shadow-2xl flex flex-col ${
          wide ? "w-full md:w-[720px]" : "w-full md:w-[520px]"
        } anim-in`}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-200">
          <h2 className="font-display text-lg font-semibold text-slate-900">{title}</h2>
          <button
            data-testid="drawer-close-btn"
            onClick={onClose}
            className="btn-ghost !p-1.5"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-5 thin-scroll">{children}</div>
        {footer && (
          <div className="border-t border-slate-200 px-5 py-4 flex items-center justify-end gap-2">
            {footer}
          </div>
        )}
      </aside>
    </div>
  );
}

export function Field({ label, children, hint }) {
  return (
    <label className="block mb-4">
      <span className="block text-xs font-medium uppercase tracking-wider text-slate-500 mb-1.5">
        {label}
      </span>
      {children}
      {hint && <span className="block text-xs text-slate-400 mt-1">{hint}</span>}
    </label>
  );
}
